export function useBrandConfig() {
  // Brand names
  const brandNameEn = process.env.BRAND_NAME_EN || 'GapGPT';
  const brandNameFa = process.env.BRAND_NAME_FA || 'گپ جی‌پی‌تی';
  const logoUrl = process.env.LOGO_URL || '/model_icons/gapgpt-icon-v3.png';
  const brandDomain = process.env.BRAND_DOMAIN || 'gapgpt.app';
  const brandEmail = process.env.BRAND_EMAIL || 'info@gapgpt.app';
  const brandCountry = process.env.BRAND_COUNTRY || 'Maryland, United States';

  const AGAPName = process.env.AGAP_NAME || brandNameEn + ' 5.5';
  const FREEGAPName = process.env.FREEGAP_NAME || brandNameEn + ' 5.5 Lite';
  const AGAP4Name = process.env.AGAP4_NAME || brandNameEn + '-4.1';
  
  // Feature flags - parse as boolean
  const showCustomGPT = process.env.SHOW_CUSTOM_GPT !== 'false';
  const showApiPlatform = process.env.SHOW_API_PLATFORM !== 'false';
  const showAppDownload = process.env.SHOW_APP_DOWNLOAD !== 'false';
  const mentionChatGPT = process.env.MENTION_CHAT_GPT !== 'false';
  const showPayment = process.env.SHOW_PAYMENT !== 'false';

  // Payment options
  const showEnterprise = process.env.SHOW_ENTERPRISE !== 'false'
  
  // Check if we're in GapGPT mode (default brand)
  const isGapGPT = brandNameEn === 'GapGPT';

  return {
    brandNameEn,
    brandNameFa,
    logoUrl,
    brandDomain,
    brandEmail,
    brandCountry,
    isGapGPT,
    
    showCustomGPT,
    showApiPlatform,
    showAppDownload,
    mentionChatGPT,
    showPayment,

    showEnterprise,

    AGAPName,
    FREEGAPName,
    AGAP4Name,
  };
}
